import React, { useState } from 'react';
import { Modal } from 'antd';
import { useConfig } from '../contexts/ConfigContext';
import { useCompany } from '../contexts/CompanyContext';
import { useSecureRequest } from '../hooks/useSecureRequest';

function LogoutModal() {
  const { config, updateConfig } = useConfig();
  const { companies } = useCompany();
  const { securePost } = useSecureRequest();
  const [loading, setLoading] = useState(false);

  const handleClose = () => updateConfig({ showLogout: false });

  const handleLogout = () => {
    setLoading(true);
    localStorage.removeItem('session');
    securePost('/security/auth/logout', {
      module: config.module || 'admin',
      company: companies.current?.uid || companies.current?.id
    })
      .then((res: any) => {
        setLoading(false);
        if (res && res.redirect) {
          window.location.href = res.redirect;
        } else {
          window.location.href = '/login';
        }
      })
      .catch((err: any) => {
        setLoading(false);
        window.location.href = '/login';
      });
  };

  return (
    <Modal
      title={<div style={{ textAlign: 'center', fontSize: '1.3rem' }}>Confirma la decisión</div>}
      open={config.showLogout}
      confirmLoading={loading}
      maskClosable={false}
      className="logout-modal-responsive"
      onOk={handleLogout}
      onCancel={handleClose}
    >
      <p style={{ marginTop: '1rem' }}>Al terminar tu sesión, se perderán los cambios que no hayas guardado</p>
    </Modal>
  );
}

export default LogoutModal;
